"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.WhatsAppSettingsForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
const component_2 = require("@front/components/form-parts/form/component");
const component_3 = require("@front/layouts/default-layout/component");
const backendImport_1 = require("@front/backendImport");
require("@front/components/form-parts/tags/component");
//@ts-ignore                
let rwsTemplate = T.html `<template>
    <div class="container-fluid">
        <div class="whatsapp-settings-form-page">
            <div class="mb-3 d-flex justify-content-between align-items-center">
                <div>
                    <h1 class="mb-0">${x => x.settingsId ? 'whatsapp.settingsForm.titleEdit'.t() : 'whatsapp.settingsForm.titleCreate'.t()}</h1>
                    ${(0, fast_element_1.when)(x => !!x.settingsId && !!x.form.phoneNumber, (0, fast_element_1.html) `
                        <p class="text-muted mb-0" style="font-size: 0.9rem;">${x => x.form.phoneNumber}</p>
                    `)}
                </div>
                <button class="btn btn-outline-secondary" @click="${x => x.cancel()}">
                    ${'whatsapp.settingsForm.back'.t()}
                </button>
            </div>

            ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
                <app-loader></app-loader>
            `)}

            ${(0, fast_element_1.when)(x => !x.loading, (0, fast_element_1.html) `
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="card card-body mb-4">
                            <the-form :onSubmit="${(x, c) => x.sendForm.bind(x)}">
                                <div class="form-group mb-3">
                                    <part-input
                                        class="form-part"
                                        label="${'whatsapp.settings.titleLabel'.t()}"
                                        :value="${x => x.form.title}"
                                        name="title"
                                        placeholder="${'whatsapp.settings.titlePlaceholder'.t()}"
                                    ></part-input>
                                </div>

                                <div class="form-group mb-3">
                                    <part-select
                                        required="true"
                                        class="form-part"
                                        label="${'whatsapp.settings.communicationTypeLabel'.t()}"
                                        :value="${x => x.form.communicationType}"
                                        name="communicationType"
                                        :options="${x => x.communicationTypeOptions}"
                                    ></part-select>
                                    <small class="form-text text-muted">${'whatsapp.settings.communicationTypeHint'.t()}</small>
                                </div>

                                ${(0, fast_element_1.when)(x => x.form.communicationType === 'TELE', (0, fast_element_1.html) `
                                    <div class="mb-3">
                                        <a href="https://my.telegram.org/apps" target="_blank" rel="noopener noreferrer">
                                            ${'whatsapp.settings.telegramApiLink'.t()}
                                        </a>
                                    </div>
                                    <div class="form-group mb-3">
                                        <part-input
                                            required="true"
                                            class="form-part"
                                            label="${'whatsapp.settings.apiIdLabel'.t()}"
                                            :value="${x => x.form.apiId}"
                                            name="apiId"
                                            placeholder="${'whatsapp.settings.apiIdPlaceholder'.t()}"
                                        ></part-input>
                                        <small class="form-text text-muted">${'whatsapp.settings.apiIdHint'.t()}</small>
                                    </div>

                                    <div class="form-group mb-3">
                                        <part-input
                                            required="true"
                                            class="form-part"
                                            label="${'whatsapp.settings.apiHashLabel'.t()}"
                                            :value="${x => x.form.apiHash}"
                                            name="apiHash"
                                            placeholder="${'whatsapp.settings.apiHashPlaceholder'.t()}"
                                        ></part-input>
                                        <small class="form-text text-muted">${'whatsapp.settings.apiHashHint'.t()}</small>
                                    </div>
                                `)}

                                <div class="form-group mb-3">
                                    <part-input
                                        mask="${x => x.phoneMask}"
                                        required="true"
                                        class="form-part"
                                        label="${'whatsapp.settings.phoneLabel'.t()}"
                                        :value="${x => x.form.phoneNumber}"
                                        name="phoneNumber"
                                        placeholder="+48 XXX XXX XXX"
                                    ></part-input>
                                    <small class="form-text text-muted">${'whatsapp.settings.phoneHint'.t()}</small>
                                </div>

                                <div class="form-group mb-3">
                                    <part-tags
                                        class="form-part"
                                        label="${'whatsapp.settings.reportEmailLabel'.t()}"
                                        :value="${x => x.form.reportEmail}"
                                        name="reportEmail"
                                        placeholder="${'whatsapp.settings.reportEmailPlaceholder'.t()}"
                                        badgeStyle="info"
                                    ></part-tags>
                                    <small class="form-text text-muted">${'whatsapp.settings.reportEmailHint'.t()}</small>
                                </div>

                                <div class="form-group mb-3">
                                    <part-select
                                        required="true"
                                        class="form-part"
                                        label="${'user.form.language.label'.t()}"
                                        :value="${x => x.form.language}"
                                        name="language"
                                        :options="${x => x.languageOptions}"
                                    ></part-select>
                                </div>

                                <div class="form-group mb-3">
                                    <part-select
                                        class="form-part"
                                        label="${'whatsapp.settings.avatarLabel'.t()}"
                                        :value="${x => x.form.avatarId}"
                                        name="avatarId"
                                        :options="${x => [{ label: 'whatsapp.settings.selectAvatar'.t(), value: '' }, ...x.availableAvatars.map(a => ({ label: a.name, value: a.id }))]}"
                                    ></part-select>
                                    <small class="form-text text-muted">${'whatsapp.settings.avatarHint'.t()}</small>
                                </div>

                                <div class="form-group mb-4">
                                    <part-textarea
                                        class="form-part"
                                        label="${'whatsapp.settings.botResponseConditionLabel'.t()}"
                                        :value="${x => x.form.botResponseCondition}"
                                        name="botResponseCondition"
                                        placeholder="${'whatsapp.settings.botResponseConditionPlaceholder'.t()}"
                                    ></part-textarea>
                                    <small class="form-text text-muted">${'whatsapp.settings.botResponseConditionHint'.t()}</small>
                                </div>

                                ${(0, fast_element_1.when)(x => x.isSuperAdmin, (0, fast_element_1.html) `
                                    <div class="form-group mb-4">
                                        <label class="form-label">${'whatsapp.settings.systemCommunicationGroupLabel'.t()}</label>
                                        <v-select
                                            class="form-part"
                                            :value="${x => x.form.systemCommunicationGroupId}"
                                            name="systemCommunicationGroupId"
                                            :choiceList="${x => x.availableGroups.map(group => ({ label: group.groupName || group.phoneNumber, value: String(group.id) }))}"
                                            placeholder="${'whatsapp.settings.selectGroup'.t()}"
                                            @change="${(x, c) => x.handleSystemCommunicationGroupChange(c.event)}"
                                        ></v-select>
                                        <small class="form-text text-muted">${'whatsapp.settings.systemCommunicationGroupHint'.t()}</small>
                                    </div>
                                `)}

                                ${(0, fast_element_1.when)(x => x.isSuperAdmin, (0, fast_element_1.html) `
                                    <div class="form-group mb-4">
                                        <part-switch
                                            class="form-part"
                                            label="${'whatsapp.settings.systemCommunicationLabel'.t()}"
                                            :value="${x => x.form.systemCommunication}"
                                            name="systemCommunication"
                                        ></part-switch>
                                        <small class="form-text text-muted">${'whatsapp.settings.systemCommunicationHint'.t()}</small>
                                    </div>
                                `)}

                                <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary" ?disabled="${x => x.saving}">
                                    ${(0, fast_element_1.when)(x => x.saving, (0, fast_element_1.html) `
                                        <span class="spinner-border spinner-border-sm me-1"></span>
                                    `)}
                                    ${'whatsapp.settings.save'.t()}
                                </button>
                            </the-form>
                        </div>
                    </div>
                </div>
            `)}
        </div>
    </div>
</template>
`;
const styles = null;
const shadowOptions = { "mode": "open" };
let WhatsAppSettingsForm = class WhatsAppSettingsForm extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.saving = false;
        this.settingsId = null;
        this.availableAvatars = [];
        this.isSuperAdmin = false;
        this.systemCommunicationGroupId = '';
        this.availableGroups = [];
        this.phoneMask = '+99 999 999 999';
        this.languageOptions = [
            { label: 'lang.pl', value: 'pl' },
            { label: 'lang.en', value: 'en' },
            { label: 'lang.de', value: 'de' },
            { label: 'lang.es', value: 'es' },
            { label: 'lang.it', value: 'it' },
            { label: 'lang.zh', value: 'zh' }
        ];
        this.communicationTypeOptions = [
            { label: 'whatsapp.settings.communicationType.wa'.t(), value: 'WA' },
            { label: 'whatsapp.settings.communicationType.tele'.t(), value: 'TELE' }
        ];
        this.form = {
            phoneNumber: '',
            title: '',
            reportEmail: [],
            language: 'pl',
            botResponseCondition: '',
            avatarId: '',
            communicationType: 'WA',
            apiId: '',
            apiHash: '',
            pinger: false,
            systemCommunication: false,
            systemCommunicationGroupId: ''
        };
        this.sendSubmit = component_2.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        var _a;
        super.connectedCallback();
        this.settingsId = this.routeParams.id || null;
        this.isSuperAdmin = ((_a = component_3.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        // Pre-set communicationType from gate's commsType when creating a new entry
        if (!this.settingsId && this.commsType) {
            this.form = { ...this.form, communicationType: this.commsType };
        }
        await Promise.all([this.loadAvatars(), this.settingsId ? this.loadSettings() : Promise.resolve()]);
        component_2.FormComponent.listenForValuesChange.bind(this)('form');
    }
    async loadAvatars() {
        try {
            const response = await this.apiService.back.get('avatar.list');
            if (response && response.success) {
                this.availableAvatars = response.data || [];
            }
        }
        catch (e) {
            console.error('Failed to load avatars', e);
        }
    }
    async loadSettings() {
        var _a;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('whatsapp.settings.getById', {
                routeParams: { id: this.settingsId }
            });
            if (response && response.success && response.data) {
                const d = response.data;
                // Parse comma-separated emails into array
                const reportEmailArray = d.reportEmail
                    ? d.reportEmail.split(',').map(e => e.trim()).filter(Boolean)
                    : [];
                this.form = {
                    phoneNumber: d.phoneNumber || '',
                    title: d.title || '',
                    reportEmail: reportEmailArray,
                    language: d.language || 'pl',
                    botResponseCondition: d.botResponseCondition || '',
                    avatarId: String(((_a = d.avatar) === null || _a === void 0 ? void 0 : _a.id) || ''),
                    communicationType: d.communicationType || 'WA',
                    apiId: d.apiId || '',
                    apiHash: d.apiHash || '',
                    pinger: !!d.pinger,
                    systemCommunication: !!d.systemCommunication,
                    systemCommunicationGroupId: d.systemCommunicationGroupId || ''
                };
                // Load groups for system communication selection
                if (this.settingsId && d.phoneNumber) {
                    try {
                        const groupsResponse = await this.apiService.back.get('whatsapp.groups.list', {
                            routeParams: { settingsId: this.settingsId },
                            queryParams: [d.phoneNumber]
                        });
                        if (groupsResponse.success && groupsResponse.data) {
                            this.availableGroups = groupsResponse.data || [];
                        }
                    }
                    catch (e) {
                        console.error('Failed to load groups for system communication:', e);
                    }
                }
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.settingsForm.loadFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('whatsapp.settingsForm.loadFailed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    async sendForm(event) {
        event.preventDefault();
        if (!this.form.phoneNumber || this.form.phoneNumber.trim() === '') {
            this.notifyService.notify('whatsapp.phoneRequired'.t(), 'error');
            return;
        }
        this.saving = true;
        try {
            let response;
            if (this.settingsId) {
                response = await this.apiService.back.put('whatsapp.settings.update', this.form, { routeParams: { id: this.settingsId } });
            }
            else {
                response = await this.apiService.back.post('whatsapp.settings.create', this.form);
            }
            if (response && response.success) {
                this.notifyService.notify('whatsapp.settingsSaved'.t(), 'info');
                component_1.SiteMenu.goto.bind(this)('/settings/comms');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.settingsSaveFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('whatsapp.settingsSaveFailed'.t(), 'error');
        }
        finally {
            this.saving = false;
        }
    }
    cancel() {
        component_1.SiteMenu.goto.bind(this)('/settings/comms');
    }
    handleSystemCommunicationGroupChange(event) {
        var _a;
        const value = ((_a = event.detail) === null || _a === void 0 ? void 0 : _a.value) || '';
        this.form = { ...this.form, systemCommunicationGroupId: value };
    }
};
exports.WhatsAppSettingsForm = WhatsAppSettingsForm;
exports.default = WhatsAppSettingsForm;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], WhatsAppSettingsForm.prototype, "commsType", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettingsForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettingsForm.prototype, "saving", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppSettingsForm.prototype, "settingsId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppSettingsForm.prototype, "availableAvatars", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettingsForm.prototype, "isSuperAdmin", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppSettingsForm.prototype, "systemCommunicationGroupId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppSettingsForm.prototype, "availableGroups", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppSettingsForm.prototype, "phoneMask", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], WhatsAppSettingsForm.prototype, "languageOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], WhatsAppSettingsForm.prototype, "communicationTypeOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], WhatsAppSettingsForm.prototype, "form", void 0);
exports.default = exports.WhatsAppSettingsForm = WhatsAppSettingsForm = __decorate([
    (0, client_1.RWSView)('whatsapp-settings-form', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], WhatsAppSettingsForm);
WhatsAppSettingsForm.defineComponent();
